import React, { useState, useEffect } from 'react';
import { Table, Row, Col, ChevronDownIcon, ContextualAlert, CaptionText, ChevronUpIcon } from '@paypalcorp/pp-react';
import { get } from 'lodash';
import { parseMessages } from '../../utilityHelper';
import withTheme from '../../common/withTheme';
const activityMsg = parseMessages("givingfund");


const ActivityTable = (props) => {
    const [activityTransactionData, setActivityTransactionData] = useState(props.activityTransactionData);
    useEffect(() => {
        if (props.showNoRecordsMsg) {
            let combinedData = activityTransactionData.concat(props.activityTransactionData);
            setActivityTransactionData(combinedData);
        } else {
            setActivityTransactionData(props.activityTransactionData);
        }
    }, [props.activityTransactionData]);
    const [showDetails, setShowDetails] = useState([]);
    const handleToggle = (Id) => {
        const showState = showDetails.slice();
        const index = showState.indexOf(Id);
        if (index >= 0) {
            showState.splice(index, 1);
            setShowDetails(showState);
        } else {
            showState.push(Id);
            setShowDetails(showState);
        }
    }

    let renderActivityTransactionData = activityTransactionData.map((actTransData, index) => {
        return (
            <>
                <tr key={index} className="showDetails" onClick={() => handleToggle(index)} >
                    <td>{actTransData.paidoutDate}</td>
                    <td>{actTransData.donor_name}</td>
                    <td> {actTransData.donor_email_address}</td>
                    <td>{actTransData.partner_name}</td>
                    <td> {actTransData.payout_description} </td>
                    <td style={{ textAlign: 'right' }} ><span className={actTransData.payout_symbol} />{actTransData.payoutAmount}</td>
                    <td style={{ textAlign: 'right' }}>
                        {showDetails.includes(index) ? (
                            <ChevronUpIcon
                                size="xs"
                                style={{ color: "#1040C1" }}

                            />
                        ) : (
                            <ChevronDownIcon
                                size="xs"
                                style={{ color: "#1040C1" }}
                                className="showDownIcon"
                            />
                        )}

                    </td>
                </tr>
                {showDetails.includes(index) && (<tr className="transSubDetails" style={{ backgroundColor: '#FAFAFA', height: '121px' }}>
                    <td className="campaignInfo" colSpan='7'>
                        <div className="col">
                            <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.donationdate')}</CaptionText></div>
                            <div className="field"><CaptionText style={{ color: '#515354' }}>{actTransData.donationDate}</CaptionText></div>
                        </div>
                        {actTransData.campaign_title &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.campaignTitle')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354' }}>{actTransData.campaign_title}</CaptionText></div>
                            </div>
                        }
                        {actTransData.item_id &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.ebayListingID')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354' }}>{actTransData.item_id}</CaptionText></div>
                            </div>
                        }
                        {actTransData.invoice_id &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.invoiceId')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354' }}>{actTransData.invoice_id}</CaptionText></div>
                            </div>
                        }
                        {actTransData.encrypted_sender_transaction_id &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.transactionId')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354' }}>{actTransData.encrypted_sender_transaction_id}</CaptionText></div>
                            </div>
                        }
                        {actTransData.gross_amount &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.grossdonationamt')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354', float: 'right' }}>{actTransData.grossAmount}</CaptionText></div>
                            </div>
                        }
                        {actTransData.total_fees &&
                            <div className="col">
                                <div className="field"><CaptionText style={{ color: '#0C0C0D' }}>{get(activityMsg, 'activity.totalfeesdeducted')}</CaptionText></div>
                                <div className="field"><CaptionText style={{ color: '#515354', float: 'right' }}><span className="neg" />{actTransData.totalFees}</CaptionText></div>
                            </div>
                        }
                    </td>
                </tr>)}
            </>
        )
    });

    return (
        <>
            <section id="activityResult">
                    <Table isFullWidth>
                        <thead>
                            <tr>
                                <th>{get(activityMsg, 'activity.payoutdate')}</th>
                                <th>
                                    {get(activityMsg, 'activity.donorname')}
                                </th>
                                <th>{get(activityMsg, 'activity.email')}</th>
                                <th>{get(activityMsg, 'activity.partner')}</th>
                                <th>{get(activityMsg, 'activity.program')}</th>
                                <th style={{ textAlign: 'right' }}>{get(activityMsg, 'activity.amount')}</th>
                                <th><p style={{ display: 'none' }}>{get(activityMsg, 'activity.rowexpandcollapse')}</p></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(renderActivityTransactionData.length == 0 && props.showNoRecordsMsg) ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        <CaptionText style={{ margin: '10px' }}>{get(activityMsg, 'activity.norecordsinfo')}</CaptionText>
                                    </td>
                                </tr>
                            ) : (renderActivityTransactionData)}
                        </tbody>
                    </Table>
                    {(props.showRecordsError) &&
                        <Row>
                            <Col>
                                <ContextualAlert type="error" style={{ margin: 'auto' }}>
                                    {get(activityMsg, 'activity.recordserror')}
                                </ContextualAlert>
                            </Col>
                        </Row>
                    }
            </section>
        </>
    )

}
export default withTheme(ActivityTable);